/* eslint-disable react/prop-types */

import { useEffect, useState } from "react";
import { Button } from "reactstrap";

interface IProps {
  isOpen: boolean;
  onClick: () => void;
  onHoverBalloon?: () => void; // ✅ dodato
}

const imagePaths = ["/logo-redo.png", "/logo-redo.png", "/logo-redo.png"];

const preloadedImages = imagePaths.map((src) => {
  const img = new Image();
  img.src = src;
  return img;
});

const MinMaxButton: React.FC<IProps> = ({ onClick, onHoverBalloon }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImage((prev) => (prev + 1) % preloadedImages.length);
        setFade(true);
      }, 300);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Button
      className="justify-content-center align-items-center min-max-button"
      onClick={onClick}
      onMouseEnter={onHoverBalloon}
    >
      <img
        src={preloadedImages[currentImage].src}
        alt="Logo"
        className={`min-max-button-icon ${fade ? "fade-in" : "fade-out"}`}
        style={{ width: 70, height: 70 }}
      />
    </Button>
  );
};

export default MinMaxButton;
